import { Box, styled, Typography } from "@mui/material";

import { useAppSelector } from "app/redux-store-interactions";
import { selectPicker } from "features/render";
import { Picker } from "features/render/types";

import { PROCORE_TOP_BAR, TOOLBAR_ANIMATION, TOOLBAR_COLORS, TOOLBAR_Z_INDEX } from "../constants";
import { PROCORE_TOOL_IDS } from "../constants";
import { selectActiveTool } from "./slice";

const PICKER_LABELS: Partial<Record<Picker, string>> = {
    [Picker.Dimension]: "Dimension",
    [Picker.PointLine]: "Point to Point",
    [Picker.OutlineLaser]: "Laser",
    [Picker.Coordinates]: "Coordinates",
    [Picker.Manhole]: "Manhole",
};

const formatToolName = (id: string) => id.charAt(0).toUpperCase() + id.slice(1);

const LabelContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== "isVisible",
})<{ isVisible: boolean }>(({ isVisible }) => ({
    position: "absolute",
    top: `${PROCORE_TOP_BAR.HEIGHT + 12}px`,
    left: "50%",
    transform: "translateX(-50%)",
    height: "32px",
    padding: "0 16px",
    backgroundColor: TOOLBAR_COLORS.BLACK,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: TOOLBAR_Z_INDEX.TOP_BAR - 1,
    pointerEvents: "none",
    opacity: isVisible ? 1 : 0,
    transition: `opacity ${TOOLBAR_ANIMATION.DURATION}ms ${TOOLBAR_ANIMATION.EASING}`,
}));

const LabelText = styled(Typography)`
    color: ${TOOLBAR_COLORS.WHITE};
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
`;

/**
 * Active Tool Label
 *
 * Displays the currently selected tool name below the top bar.
 * Black background, width fits text, 32px height.
 * Shows when a tool is active, hides when tool is saved/exited.
 */
export function ActiveToolLabel() {
    const activeTool = useAppSelector(selectActiveTool);
    const picker = useAppSelector(selectPicker);
    const isVisible = activeTool !== null;

    let toolName = activeTool ? formatToolName(activeTool) : "";
    if (activeTool === PROCORE_TOOL_IDS.MEASURE && PICKER_LABELS[picker]) {
        toolName = PICKER_LABELS[picker];
    }

    return (
        <LabelContainer isVisible={isVisible}>
            <LabelText>{toolName}</LabelText>
        </LabelContainer>
    );
}
